import { AnswerDto, AnswerModel, mapAnswerDtoToModel } from 'api/dto/Answer.dto';
import dayjs, { Dayjs } from 'dayjs';

export enum ProjectSubmitStatus {
  Started = 0,
  Partial = 1,
  Completed = 2,
}

export type ProjectSubmitRespondent = {
  email: string;
  firstName: string;
  lastName: string;
};

export type ProjectSubmitDto = {
  id: number;
  status: number;
  submitTime: string;
  respondent: ProjectSubmitRespondent;
  answers?: AnswerDto[];
};

export type ProjectSubmitModel = {
  id: number;
  status: ProjectSubmitStatus;
  submitTime?: Dayjs;
  email?: string;
  firstName?: string;
  lastName?: string;
  answers?: AnswerModel[];
};

export function mapProjectSubmitDtoToModel(dto: ProjectSubmitDto): ProjectSubmitModel {
  return {
    id: dto.id,
    status: dto.status,
    submitTime: dayjs(Date.parse(dto.submitTime)),
    email: dto.respondent && dto.respondent.email,
    firstName: dto.respondent && dto.respondent.firstName,
    lastName: dto.respondent && dto.respondent.lastName,
    answers: (dto.answers || []).map((answerDto) => mapAnswerDtoToModel(answerDto)),
  };
}

export namespace ProjectSubmitModel {
  export function getName(projectSubmitModel: ProjectSubmitModel): string {
    return projectSubmitModel.firstName
      ? `${projectSubmitModel.firstName} ${projectSubmitModel.lastName}`
      : '';
  }
}
